// @flow

import React, { Fragment } from "react";
import { Row, Col, Label, Icon } from "@components";
import { DatePicker } from "@components";
import { Input } from "reactstrap";
import { ToggleButton } from "../toggle-button";
import ComboBox from "../combobox";
import { TooltipDropdown } from "../index";
import type { OptionType } from "@components";

const FREE_TEXT = "FREE_TEXT";
const DATE_PICK = "DATE_PICK";
const SINGLE_SELECT = "SINGLE_SELECT";
const MULTI_SELECT = "MULTI_SELECT";
const CONFIRMATION = "CONFIRMATION";

export type Question = $Exact<{
  id: number,
  type:
    | typeof FREE_TEXT
    | typeof DATE_PICK
    | typeof SINGLE_SELECT
    | typeof MULTI_SELECT
    | typeof CONFIRMATION,
  mandatory: boolean,
  text: string,
  selectableValues?: string[],
  questionLabel?: string,
  captureConsentToShare?: boolean,
  masterStandardQuestionId?: number,
  tooltip?: string,
  key?: string,
  questionText?: string,
}>;

export type Props = $Exact<{
  question: Question,
  onChange: Object => void,
  consentToShare: ?boolean,
  answer?: string | boolean,
  value?: any,
}>;

export type State = $Exact<{
  comboBoxValue: string,
}>;

export class SingleQuestionAnswerWithConsent extends React.Component<Props, State> {
  state = {
    comboBoxValue: "",
  };

  get idName() {
    return this.props.question.questionLabel
      ? `${this.props.question.questionLabel}-${this.props.question.id}`
      : `${this.props.question.id}`;
  }

  handleChange = (value: ?string | (string | number)[]) => {
    this.props.onChange({
      [this.idName]: {
        answer: value,
        id: this.props.question.id,
      },
    });
  };

  handleInputChange = (e: Object) => {
    this.props.onChange({
      [this.idName]: {
        answer: e.target.value,
        id: this.props.question.id,
      },
    });
  };

  handleComboBoxChange = (val: OptionType) => {
    this.setState({
      comboBoxValue: val,
    });

    this.props.onChange({
      [this.idName]: {
        answer: val,
        id: this.props.question.id,
      },
    });
  };

  handleConsentChange = (value: boolean) => {
    this.props.onChange({
      [this.idName]: {
        consentToShare: value,
        id: this.props.question.id,
      },
    });
  };

  renderFormField = (questionType: string) => {
    switch (questionType) {
      case DATE_PICK:
        return <DatePicker onChange={this.handleChange} value={this.props.value || ""} />;
      case FREE_TEXT:
        return (
          <Input
            type="textarea"
            onChange={this.handleInputChange}
            defaultValue={this.props.value}
          />
        );
      case SINGLE_SELECT:
        return (
          <ComboBox
            onChange={this.handleComboBoxChange}
            options={
              this.props.question.selectableValues
                ? this.props.question.selectableValues.map(value => ({ value, label: value }))
                : []
            }
            value={{
              value: this.state.comboBoxValue || this.props.value,
              label: this.state.comboBoxValue || this.props.value,
            }}
            withoutEmptyOption
          />
        );
      case MULTI_SELECT:
        return (
          <ComboBox
            isMulti
            onChange={this.handleChange}
            options={
              this.props.question.selectableValues
                ? this.props.question.selectableValues.map(value => ({ value, label: value }))
                : []
            }
            value={(this.props.value || []).map(value => ({ value, label: value }))}
          />
        );
      case CONFIRMATION:
        return (
          <ToggleButton
            onChange={this.handleChange}
            items={[
              {
                label: "Yes",
                value: true,
                active: this.props.value === true,
              },
              {
                label: "No",
                value: false,
                active: this.props.value === false,
              },
            ]}
          />
        );
      default:
        return "";
    }
  };

  get questionLabel() {
    const { question } = this.props;
    return (
      <Label className="font-size-14 font-weight-bold">
        {question.text}
        {question.mandatory && <Icon icon="asterisk" size="xs" className="text-warning ml-2" />}
      </Label>
    );
  }

  render() {
    const { question, consentToShare } = this.props;
    return (
      <div className="single-question-answer-with-consent">
        {question.type ? (
          <Fragment>
            <Row>
              <Col>
                <div>
                  {question.tooltip ? (
                    <TooltipDropdown
                      description={question.tooltip}
                      id={`tooltip-id-${question.id}`}
                      className="d-inline"
                    >
                      {this.questionLabel}
                    </TooltipDropdown>
                  ) : (
                    this.questionLabel
                  )}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>{this.renderFormField(question.type)}</Col>
            </Row>
            {/*{question.captureConsentToShare !== false && (*/}
            {/*  <Row>*/}
            {/*    <Col className="mt-2">*/}
            {/*      <ToggleButton*/}
            {/*        className="d-flex"*/}
            {/*        items={[*/}
            {/*          {*/}
            {/*            label: "OK to Share",*/}
            {/*            activeColor: "positive",*/}
            {/*            value: true,*/}
            {/*            active: consentToShare === true,*/}
            {/*            buttonClassName: "extra-small text-nowrap",*/}
            {/*          },*/}
            {/*          {*/}
            {/*            label: "Don't Share",*/}
            {/*            activeColor: "negative",*/}
            {/*            value: false,*/}
            {/*            active: consentToShare === false,*/}
            {/*            buttonClassName: "extra-small  text-nowrap",*/}
            {/*          },*/}
            {/*        ]}*/}
            {/*        onChange={this.handleConsentChange}*/}
            {/*      />*/}
            {/*    </Col>*/}
            {/*  </Row>*/}
            {/*)}*/}
          </Fragment>
        ) : (
          <Col>
            <div>
              {question.tooltip ? (
                <TooltipDropdown
                  description={question.tooltip}
                  id={`tooltip-id-${question.id}`}
                  className="d-inline"
                >
                  <Label className="small-font-size">{question.text}</Label>
                </TooltipDropdown>
              ) : (
                <Label className="small-font-size">{question.text}</Label>
              )}
            </div>
          </Col>
        )}
      </div>
    );
  }
}

export default SingleQuestionAnswerWithConsent;
